import { Vector2 as BJSVector2, Vector3 as BJSVector3, Quaternion as BJSQuaternion } from "@babylonjs/core/Maths/math.vector";
import { Color3 as BJSColor3 } from "@babylonjs/core/Maths/math.color";
import { ERR_INVALID_ARGUMENT } from "../../utils/error";
import { roundTo } from "../../utils/math";
import { isNumber } from "../../utils/number";
export function stringifyToJson(pData) {
    if (pData == null)
        throw new Error(ERR_INVALID_ARGUMENT);
    const tJson = JSON.stringify(pData, (pKey, pValue) => {
        //reduce decimal places for numbers
        if (isNumber(pValue))
            return (roundTo(pValue, 6));
        return (pValue);
    });
    return (tJson);
}
export function serializeQuaternion(pQ) {
    if (pQ == null)
        throw new Error(ERR_INVALID_ARGUMENT);
    return ([pQ.x, pQ.y, pQ.z, pQ.w]);
}
export function deserializeQuaternion(pQ) {
    if (pQ == null)
        throw new Error(ERR_INVALID_ARGUMENT);
    return (new BJSQuaternion(pQ[0], pQ[1], pQ[2], pQ[3]));
}
export function serializeVector2(pV) {
    if (pV == null)
        throw new Error(ERR_INVALID_ARGUMENT);
    return ([pV.x, pV.y]);
}
export function deserializeVector2(pV) {
    if (pV == null)
        throw new Error(ERR_INVALID_ARGUMENT);
    return (new BJSVector2(pV[0], pV[1]));
}
export function serializeVector3(pV) {
    if (pV == null)
        throw new Error(ERR_INVALID_ARGUMENT);
    return ([pV.x, pV.y, pV.z]);
}
export function deserializeVector3(pV) {
    if (pV == null)
        throw new Error(ERR_INVALID_ARGUMENT);
    return (new BJSVector3(pV[0], pV[1], pV[2]));
}
export function serializeColor3(pC) {
    if (pC == null)
        throw new Error(ERR_INVALID_ARGUMENT);
    return ([pC.r, pC.g, pC.b]);
}
export function deserializeColor3(pC) {
    if (pC == null)
        throw new Error(ERR_INVALID_ARGUMENT);
    return (new BJSColor3(pC[0], pC[1], pC[2]));
}
